export function validateWhatsAppUrl(value) {
  if (!value || typeof value !== "string") return "";
  try {
    const url = new URL(value.trim());
    const allowedHost = url.hostname === "chat.whatsapp.com" || url.hostname === "wa.me";
    return url.protocol === "https:" && allowedHost && url.pathname.length > 1 ? url.toString() : "";
  } catch {
    return "";
  }
}

const configuredWhatsAppUrl = validateWhatsAppUrl(
  process.env.REACT_APP_UUN_WHATSAPP_COMMUNITY_URL
);

if (process.env.NODE_ENV === "development" && !configuredWhatsAppUrl) {
  console.warn("Set REACT_APP_UUN_WHATSAPP_COMMUNITY_URL to a valid HTTPS WhatsApp invitation URL.");
}

export const uunConfig = {
  whatsappCommunityUrl: configuredWhatsAppUrl,
  whatsappQrImageUrl: "/whatsapp-community-qr.png",
};
